export default "__VITE_PUBLIC_ASSET__f2c00373__"